import { Component, OnInit } from '@angular/core';
import { SurveyQuestionVm } from '../models/surveyquestionVm';
import { SurveyService } from "../services/survey.service";
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-covid-return-to-work',
  templateUrl: './covid-return-to-work.component.html',
  styleUrls: ['./covid-return-to-work.component.css']
})
export class CovidReturnToWorkComponent implements OnInit {

  questions: SurveyQuestionVm[];
  constructor(private surveyServiceProxy: SurveyService,) { }

  env: string;
  async ngOnInit() {
    this.env = environment.headerBanner;
    // this.stateService.hideHeaderSideBar();
    this.questions = await this.surveyServiceProxy.getCovidReturnToWorkQuestions().toPromise();
    console.log(this.questions);
  }

}
